// 直播内容类型
export const PACKAGE_TYPE_ID = 4
export const CASE_TYPE_ID = 7
export const HALL_TYPE_ID = 8

// 推广类型
export const MERCHANT_SPREAD = 1 // 商家推广 1商家建推广,2商家建非推广,3运营建推广,4运营建非推广'
export const MERCHANT_NO_SPREAD = 2 // 商家建非推广
export const OPERATE_SPREAD = 3 // 运营建推广
export const OPERATE_NO_SPREAD = 4 // 商家建非推广

// 直播状态
export const VIDEO_LIVING = 1 // 直播中
export const VIDEO_COMING = 2 // 直播即将开始
export const VIDEO_REVIEW = 3 // 回顾直播
export const VIDEO_IN_AUDIT = 4 // 待完善

// 优惠券类型
export const COUPON_FULL_REDUCTION = 1 // 满减
export const COUPON_UNLIMITED = 2 // 无限制

// 标签类型
export const HOST_PAP = 1 // 主播说
export const GROUP_PAP = 2 // 大家说
export const USER_PAP = 3 // 禁言用户列表

// 禁言状态
export const FORBIDDEN_WORD = 1 // 禁言
export const ALLOW_WORD = 2 // 允许发言

// 消息类型
export const MSG_IMG_AND_TEXT = 1 // 图文消息
export const MSG_CASH_PACKAGE = 4 // 红包消息
export const MSG_COUPON = 5 // 图文消息
export const MSG_PACKAGE_CONFIG = 7 // 设置套餐介绍中
export const MSG_HALL_CONFIG = 15 // 设置婚宴厅介绍中
export const MSG_INTENT_CONFIG = 17 // 设置套餐意向金

//连麦状态
export const liveLinkMicrophoneWait = 11 //等待
export const liveLinkMicrophoneCancel = 12 //取消
export const liveLinkMicrophoneStart = 13 //接入
export const liveLinkMicrophoneStop = 14 //终止
export const liveLinkMicrophoneStatus = [
  liveLinkMicrophoneWait,
  liveLinkMicrophoneCancel,
  liveLinkMicrophoneStart,
  liveLinkMicrophoneStop
]

// 直播网络状态
export const livingNetStatus = 16
